import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiGet } from "../../shared/apiClient";

/** `/order-details?edit={lineId}` opens the order editor on the Order details tab. */
export function OrderDetailsPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const editParam = searchParams.get("edit");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!editParam) {
        navigate("/order-details-list", { replace: true });
        return;
      }
      const id = Number(editParam);
      if (!Number.isFinite(id)) {
        navigate("/order-details-list", { replace: true });
        return;
      }
      const res = await apiGet(`/api/OrderDetails/${id}`);
      if (cancelled) return;
      if (!res.ok) {
        navigate("/order-details-list", { replace: true });
        return;
      }
      navigate(`/orders?edit=${res.data.orderId}&tab=details&detailEdit=${id}`, { replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [editParam, navigate]);

  return (
    <div className="card">
      <div className="card-body">
        <p>Redirecting…</p>
      </div>
    </div>
  );
}
